
export const SAFE_PERCENT = 0.6;
export const MAX_PERCENT = 0.75;

export function isPhone(text) {
    let reg = new RegExp('^1\\d{10}$');
    return reg.test(text);
}

export function isMail(text) {
    let reg = new RegExp(/^[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@((?:[\w](?:[\w-]*[\w])?\.)+)[a-zA-Z]{2,}$/);
    return reg.test(text);
}

export function hidePhone(phone) {
    let reg = /^(\d{3})\d*(\d{4})$/;
    let ret = phone.replace(reg, '$1****$2')
    return ret;
}

export function rem2px(rem) {
    let pc = isPC() && document.documentElement.clientWidth > 750;
    if (pc) {
        let px = document.body.clientWidth / 28.80 * rem;
        return Math.round(px);
    } else {
        let px = document.body.clientWidth / 7.5 * rem;
        return Math.round(px);
    }
}

export function px2rem(px) {
    let pc = isPC() && document.documentElement.clientWidth > 750;
    if (pc) {
        let rem = 28.8 * px / document.body.clientWidth;
        return Math.round(rem);
    } else {
        let rem = 7.5 * px / document.body.clientWidth;
        return Math.round(rem);
    }
}

export function isPC() {
    var userAgentInfo = navigator.userAgent;
    var Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone",
        "iPad", "iPod"];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}

export function isAndroid() {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    return isAndroid;
}

export function isIOS() {
    var u = navigator.userAgent;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    return isiOS;
}

export function isIphoneFullScreen() {
    // 判断是iphoneX及以后的iphone手机（即iphone带全面屏的手机）
    return window && navigator.userAgent.indexOf('iPhone') > -1
        && window.screen.height >= 812 && window.devicePixelRatio >= 2;
}

export function isSafari() {
    let ua = navigator.userAgent;
    // alert(ua)
    var issafariBrowser = /Safari/.test(ua) && !/Chrome/.test(ua) && !/MQQBrowser/.test(ua) && !/iPad/.test(ua);
    console.log('isSafari --> ', issafariBrowser);
    return issafariBrowser;
    // return false;
}

export function isWx() {
    let ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) === 'micromessenger') {
        return true;
    } else {
        return false;
    }
}

export function getHashValue() {
    var hash = window.location.hash;
    if (!hash) {
        return '';
    }
    if (hash.indexOf('&') > 0) {
        hash = hash.substr(0, hash.indexOf('&'));
    }
    if (hash.indexOf('?') > 0) {
        hash = hash.substr(0, hash.indexOf('?'));
    }
    return hash;
}

export function randomFee() {
    let fee = (0.001 + 0.004 * Math.random()).toFixed(4);
    return fee;
}

// 时间格式化一分钟前、几天前
// time 2018-05-25 18:14:02
export function getDateDiff(time) {
    if (!time) {
        return '';
    }
    // 当前时间
    var nowTime = new Date();
    var year = nowTime.getFullYear();
    var month = nowTime.getMonth() + 1;
    var day = nowTime.getDate();
    var hours = parseInt(nowTime.getHours());
    var minutes = nowTime.getMinutes();
    // 传来time 2018-05-25 18:14:02 分解
    var timeYear = time.substring(0, 4);
    var timeMonth = time.substring(5, 7);
    var timeday = time.substring(8, 10);
    var timehours = parseInt(time.substring(11, 13));
    var timeminutes = time.substring(14, 16);
    var d_day = Math.abs(day - timeday);
    var d_hours = hours - timehours;
    var d_minutes = Math.abs(minutes - timeminutes);
    if (year === timeYear && month === timeMonth && d_day <= 1) {
        if(d_day === 0 ) {
            if (d_hours === 0 && d_minutes > 0) {
                return d_minutes + '分钟前';
            } else if (d_hours === 0 && d_minutes === 0) {
                return '1分钟前';
            } else {
                return d_hours + '小时前';
            }
        } else {
            if (d_hours < 0) {
                return (24 + d_hours) + '小时前';
            } else {
                return d_day + '天前';
            }
        }
    } else if (year === timeYear && month === timeMonth && d_day > 1 && d_day < 10) {
        return d_day + '天前';
    } else {
        return timeYear + '-' + timeMonth + '-' + timeday;
    }
}

const wrapSymbol = (symbol) => {
    if (symbol === 'WETH') {
        return 'ETH';
    } else if (symbol === 'WBNB') {
        return 'BNB';
    }
    return symbol;
}

export function unwrapETH(obj) {
    if (typeof obj === 'string') {
        return wrapSymbol(obj);
    }

    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'bigint') {
        return obj;
    }

    if (obj instanceof Array) {
        for (let i = 0; i < obj.length; i++) {
            obj[i] = unwrapETH(obj[i]);
        }
        return obj;
    }
    let symbolOrigin = undefined;
    let baseSymbolOrigin = undefined;
    let quoteSymbolOrigin = undefined;
    for (let key in obj) {
        if (key === 'symbol' || key === 'base_symbol' || key === 'quote_symbol') {
            let symbol = obj[key];
            if (key === 'symbol') {
                symbolOrigin = symbol;
            } else if (key === 'base_symbol') {
                baseSymbolOrigin = symbol;
            } else if (key === 'quote_symbol') {
                quoteSymbolOrigin = symbol;
            }
            if (symbol.length > 10) {
                symbol = symbol.substr(0, 8) + '...';
                obj[key] = symbol;
            }
        }
        obj[key] = unwrapETH(obj[key]);
    }
    if (symbolOrigin) {
        obj.symbolOrigin = wrapSymbol(symbolOrigin);
    }
    if (baseSymbolOrigin) {
        obj.baseSymbolOrigin = wrapSymbol(baseSymbolOrigin);
    }
    if (quoteSymbolOrigin) {
        obj.quoteSymbolOrigin = wrapSymbol(quoteSymbolOrigin);
    }
    return obj;
}

export function getRateColor(rate) {
    rate = parseFloat(rate);
    if (rate > 0) {
        return '#15C076';
    } else if(rate < 0){
        return '#F84860';
    } else {
        return '#202020';
    }
}

export function formatRate(rate) {
    rate = parseFloat(rate) * 100;
    if (rate >= 0) {
        rate = parseFloat(rate.toFixed(2));
        return '↑' + rate + '%';
    } else {
        rate = parseFloat(rate.toFixed(2));
        return '↓' + Math.abs(rate) + '%'
    }
}

// 取几位小数点
export function floatToFixed(value, num = 2) {
    if (isNaN(value)) {
        return 0;
    }
    var n = Math.pow(10, num);

    return parseFloat(Number(Math.floor(value * n) / n).toFixed(num));
}

export const formatPrice = (price) => {
    if (price) {
        let floatPrice = parseFloat(price);
        if (floatPrice > 10000000) {
            return floatPrice.toPrecision(5);
        } else if (floatPrice < 0.0001 && floatPrice > 0) {
            return floatPrice.toExponential(2);
        }
        return floatPrice.toFixed(2);
    } else {
        return 0;
    }
}

export const formatTVL = (tvl) => {
    let _tvl = parseFloat(tvl);
    if (_tvl >= 1000000000) {
        _tvl = floatToFixed(_tvl / 1000000000, 2);
        return _tvl + 'B';
    }
    if (_tvl >= 1000000) {
        _tvl = floatToFixed(_tvl / 1000000, 2);
        return _tvl + 'M';
    }
    if (_tvl >= 1000) {
        _tvl = floatToFixed(_tvl / 1000, 2);
        return _tvl + 'K';
    }
    return floatToFixed(tvl, 2);
}

export function shortAddress(address, left = 8, right = 5) {
    if (!address || address.length < 42) {
        return address;
    }
    return address.substr(0, left) + '...' + address.substr(-right);
}

export function wrapCertified(data){
    if (!data || data.length === 0) {
        return data;
    }
    if (data instanceof Array){
        // risk_type, //0：未知，1：安全，2：警告， 3：风险
        // is_certified, //0: normal; 1: certified
        data.forEach(p => {
            if (p.is_certified === 1 && p.risk_type > 1) {
                p.risk_type -= 1;
            }
        });
    } else if (typeof data === 'object') {
        if (data.is_certified === 1 && data.risk_type > 1) {
            data.risk_type -= 1;
        }
    }
    return data;
}

export function toLowerCaseEquals(text1, text2) {
    if (text1 && text2 && text1.toLowerCase() === text2.toLowerCase()) {
        return true;
    }
    return text1 === text2;
}